import { render, staticRenderFns } from "./TipList.vue?vue&type=template&id=94bdd768"
import script from "./TipList.vue?vue&type=script&lang=ts"
export * from "./TipList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports